import React from "react";
import { useLocation } from "react-router-dom";

/**
 * Titulo da aba por area do app. O `public/index.html` tem um titulo estatico
 * unico para todo o SPA, entao a aba do admin aparecia como "Cardapio Online".
 * Aqui o titulo passa a refletir onde o usuario esta.
 */
const DEFAULT_TITLE = "MenuChef - Cardápio Online";

export function titleForPath(pathname: string): string {
  if (pathname.startsWith("/admin")) return "MenuChef - Admin";
  if (pathname.startsWith("/menu")) return "MenuChef - Cardápio";
  if (pathname.startsWith("/store")) return "MenuChef - Pedido";
  return DEFAULT_TITLE;
}

export default function DocumentTitle() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    document.title = titleForPath(pathname);
  }, [pathname]);

  return null;
}
